export enum Tier {
  tier0 = 'tier0',
  tier1 = 'tier1',
  tier2 = 'tier2',
  tier90 = 'tier90',
  tier99 = 'tier99',
  admin = 'admin',
}
